<template>
	<div class="main" v-if="loading">
		<div class="main-item">
			<div class="title">
				<div>我的好友</div>
			</div>
			<div class="content" v-if="myGeniusFriendsList.total">
				<div class="content-item" v-for="(item,index) in myGeniusFriendsList.data">
					<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
					<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
						@click="toCancelFansNperson(item)" v-else>已关注</div>
						
					<div v-if="isDataString(item.avatar)" class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='item.avatar' alt="">
					</div>
					<div v-else class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='getImgSrc(item.avatar)' alt="">
					</div>
					<div style="width: 100%;text-align: center;">
						<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
					</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
			<div class="bottom-btn">
				<div v-if="myGeniusFriendsList.current_page != 1" @click="pagePreviousOrNext('myGeniusFriendsList','sub')">上一批</div>
				<div style="color: white;background: #0052d9;"
					v-if="myGeniusFriendsList.current_page < myGeniusFriendsList.last_page"@click="pagePreviousOrNext('myGeniusFriendsList','add')">换一批</div>
			</div>
		</div>
		<div class="main-item">
			<div class="title">
				<div>我的关注</div>
			</div>
			<div class="content" v-if="careGeniusList.total > 0">
				<div class="content-item" v-for="(item,index) in careGeniusList.data">
					<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
					<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
						@click="toCancelFansNperson(item)" v-else>已关注</div>
					<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='getImgSrc(item.avatar)' alt="">
					</div>
					<div style="width: 100%;text-align: center;">
						<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
					</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
			<div class="bottom-btn">
				<div v-if="careGeniusList.current_page != 1" @click="pagePreviousOrNext('careGeniusList','sub')">上一批</div>
				<div style="color: white;background: #0052d9;"
					v-if="careGeniusList.current_page < careGeniusList.last_page" @click="pagePreviousOrNext('careGeniusList','add')">换一批</div>
			</div>
		</div>
		<div class="main-item">
			<div class="title">
				<div>牛人榜(积分)</div>
			</div>
			<div class="content" v-if="GeniusScoreRank.total">
				<div class="content-item" v-for="(item,index) in GeniusScoreRank.data">
					<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
					<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
						@click="toCancelFansNperson(item)" v-else>已关注</div>
					<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='getImgSrc(item.avatar)' alt="">
					</div>
					<div style="width: 100%;text-align: center;">
						<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
					</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
			<div class="bottom-btn">
				<div v-if="GeniusScoreRank.current_page != 1" @click="pagePreviousOrNext('GeniusScoreRank','sub')">上一批</div>
				<div style="color: white;background: #0052d9;"
					v-if="GeniusScoreRank.current_page < GeniusScoreRank.last_page" @click="pagePreviousOrNext('GeniusScoreRank','add')">换一批</div>
			</div>
		</div>
		<div class="main-item">
			<div class="title">
				<div>牛人榜(声望)</div>
			</div>
			<div class="content" v-if="GeniusReputationRank.total">
				<div class="content-item" v-for="(item,index) in GeniusReputationRank.data">
					<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
					<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
						@click="toCancelFansNperson(item)" v-else>已关注</div>
					<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='getImgSrc(item.avatar)' alt="">
					</div>
					<div style="width: 100%;text-align: center;">
						<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
					</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
			<div class="bottom-btn">
				<div v-if="GeniusReputationRank.current_page != 1" @click="pagePreviousOrNext('GeniusReputationRank','sub')">上一批</div>
				<div style="color: white;background: #0052d9;"
					v-if="GeniusReputationRank.current_page < GeniusReputationRank.last_page" @click="pagePreviousOrNext('GeniusReputationRank','add')">换一批</div>
			</div>
		</div>
		<div class="main-item">
			<div class="title">
				<div>牛人榜(活跃)</div>
			</div>
			<div class="content" v-if="GeniusActiveRank.total">
				<div class="content-item" v-for="(item,index) in GeniusActiveRank.data">
					<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
					<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
						@click="toCancelFansNperson(item)" v-else>已关注</div>
					<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='getImgSrc(item.avatar)' alt="">
					</div>
					<div style="width: 100%;text-align: center;">
						<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
					</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
			<div class="bottom-btn">
				<div v-if="GeniusActiveRank.current_page != 1" @click="pagePreviousOrNext('GeniusActiveRank','sub')">上一批</div>
				<div style="color: white;background: #0052d9;"
					v-if="GeniusActiveRank.current_page < GeniusActiveRank.last_page" @click="pagePreviousOrNext('GeniusActiveRank','add')">换一批</div>
			</div>
		</div>
		<div class="main-item">
			<div class="title">
				<div>牛人榜(贡献)</div>
			</div>
			<div class="content" v-if="getGeniusContributeTop.total">
				<div class="content-item" v-for="(item,index) in getGeniusContributeTop.data">
					<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
					<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
						@click="toCancelFansNperson(item)" v-else>已关注</div>
					<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='getImgSrc(item.avatar)' alt="">
					</div>
					<div style="width: 100%;text-align: center;">
						<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
					</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
			<div class="bottom-btn">
				<div v-if="getGeniusContributeTop.current_page != 1" @click="pagePreviousOrNext('getGeniusContributeTop','sub')">上一批</div>
				<div style="color: white;background: #0052d9;"
					v-if="getGeniusContributeTop.current_page < getGeniusContributeTop.last_page" @click="pagePreviousOrNext('getGeniusContributeTop','add')">换一批</div>
			</div>
		</div>
		<div class="main-item">
			<div class="title">
				<div>我的同事</div>
			</div>
		<div v-if="myGeniusColleague">
			<div class="content" v-if="myGeniusColleague.total">
				<div class="content-item" v-for="(item,index) in myGeniusColleague.data">
					<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
					<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
						@click="toCancelFansNperson(item)" v-else>已关注</div>
					<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='getImgSrc(item.avatar)' alt="">
					</div>
					<div style="width: 100%;text-align: center;">
						<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
					</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
			<div class="bottom-btn">
				<div v-if="myGeniusColleague.current_page != 1" @click="pagePreviousOrNext('myGeniusColleague','sub')">上一批</div>
				<div style="color: white;background: #0052d9;"
					v-if="myGeniusColleague.current_page < myGeniusColleague.last_page" @click="pagePreviousOrNext('myGeniusColleague','add')">换一批</div>
			</div>
			
		</div>
		<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
			<el-empty :image-size="150"></el-empty>
		</div>
		</div>
		<div class="main-item">
			<div class="title">
				<div>我的校友</div>
			</div>
			<div v-if="myGeniusSchoolmate">
				<div class="content" v-if="myGeniusSchoolmate.total">
					<div class="content-item" v-for="(item,index) in myGeniusSchoolmate.data">
						<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
						<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
							@click="toCancelFansNperson(item)" v-else>已关注</div>
						<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
							<img :src='getImgSrc(item.avatar)' alt="">
						</div>
						<div style="width: 100%;text-align: center;">
							<p>{{item.nickname}}</p>
							<p>{{item.school}}</p>
							<p>{{item.qualification}}</p>
						</div>
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="150"></el-empty>
				</div>
				<div class="bottom-btn">
					<div v-if="myGeniusSchoolmate.current_page != 1" @click="pagePreviousOrNext('myGeniusSchoolmate','sub')">上一批</div>
					<div style="color: white;background: #0052d9;"
						v-if="myGeniusSchoolmate.current_page < myGeniusSchoolmate.last_page" @click="pagePreviousOrNext('myGeniusSchoolmate','add')">换一批</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
		</div>
		<div class="main-item">
			<div class="title">
				<div>为您推荐</div>
			</div>
			<div class="content" v-if="recommendGeniusList.total">
				<div class="content-item" v-for="(item,index) in recommendGeniusList.data">
					<div class="guanzhu" v-if="!item.fans_status" @click="toFansNperson(item)">关注</div>
					<div class="guanzhu" style="width: 60px;color: #8c8c8c;background-color: #cccccc;"
						@click="toCancelFansNperson(item)" v-else>已关注</div>
					<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
						<img :src='getImgSrc(item.avatar)' alt="">
					</div>
					<div style="width: 100%;text-align: center;">
						<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
					</div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
			<div class="bottom-btn">
				<div v-if="recommendGeniusList.current_page != 1" @click="pagePreviousOrNext('recommendGeniusList','sub')">上一批</div>
				<div style="color: white;background: #0052d9;"
					v-if="recommendGeniusList.current_page < recommendGeniusList.last_page" @click="pagePreviousOrNext('recommendGeniusList','add')">换一批</div>
			</div>
		</div>
	</div>
</template>

<script>
	// // celebrity/get_contribution_celebrity_lists  贡献排行榜
	// getGeniusContributeTop: (option) => { return post('/celebrity/get_contribution_celebrity_lists',qs.stringify(option))},
	// // celebrity/get_recommend 为你推荐牛人
	// recommendGeniusList: (option) => { return post('/celebrity/get_recommend',qs.stringify(option))},
	// // celebrity/get_my_fans_user 我的关注
	// careGeniusList: (option) => { return post('/celebrity/get_my_fans_user',qs.stringify(option))},
	// // celebrity/get_friend 我的好友
	// myGeniusFriendsList: (option) => { return post('/celebrity/get_friend',qs.stringify(option))},
	// // celebrity/fans_user 关注牛人
	// toFansGenius: (option) => { return post('/celebrity/fans_user',qs.stringify(option))},
	// // celebrity/fans_user_del 取消关注
	// cancelGeniusFans: (option) => { return post('/celebrity/fans_user',qs.stringify(option))},
	// // celebrity/get_my_colleague 我的同事
	// myGeniusColleague: (option) => { return post('/celebrity/get_my_colleague',qs.stringify(option))},
	// // celebrity/get_my_schoolmate 我的校友
	// myGeniusSchoolmate: (option) => { return post('/celebrity/get_my_schoolmate',qs.stringify(option))},
	// // celebrity/get_score_celebrity_lists 牛人积分榜
	// GeniusScoreRank: (option) => { return post('/celebrity/get_score_celebrity_lists',qs.stringify(option))},
	// // celebrity/get_prestige_celebrity_lists 牛人声望榜
	// GeniusReputationRank: (option) => { return post('/celebrity/get_prestige_celebrity_lists',qs.stringify(option))},
	// // celebrity/get_active_celebrity_lists 牛人活跃榜
	// GeniusActiveRank: (option) => { return post('/celebrity/get_active_celebrity_lists',qs.stringify(option))},
	export default {
		data() {
			return {
				myGeniusFriendsList: [],
				careGeniusList: [],
				GeniusScoreRank: [],
				GeniusReputationRank:[],
				friendsListPage: 1,
				GeniusActiveRank:[],
				getGeniusContributeTop:[],
				myGeniusColleague:[],
				myGeniusSchoolmate:[],
				recommendGeniusList:[],
				listObj: {
					myGeniusFriendsList:async (page)=>{
						return await this.$api.myGeniusFriendsList({page:page})
					},
					careGeniusList:async (page)=>{
						return await this.$api.careGeniusList({page:page})
					},
					GeniusScoreRank:async (page)=>{
						return await this.$api.GeniusScoreRank({page:page})
					},
					recommendGeniusList:async (page)=>{
						return await this.$api.recommendGeniusList({page:page})
					},
					myGeniusSchoolmate:async (page)=>{
						return await this.$api.myGeniusSchoolmate({page:page})
					},
					GeniusActiveRank:async (page)=>{
						return await this.$api.GeniusActiveRank({page:page})
					},
					GeniusReputationRank:async (page)=>{
						return await this.$api.GeniusReputationRank({page:page})
					},
					getGeniusContributeTop:async (page)=>{
						return await this.$api.getGeniusContributeTop({page:page})
					},
					myGeniusColleague:async (page)=>{
						return await this.$api.myGeniusColleague({page:page})
					},
				},
				loading: false
			}
		},
		created() {
			this.getMyFriendsList()
		},
		methods: {
			pagePreviousOrNext(list,type){
				if(type == 'add'){
					if(this[list].current_page >= this[list].last_page) return
					this[list].current_page += 1
				}else{
					if(this[list].current_page <= 1) return
					this[list].current_page -= 1
				}
				this.listObj[list](this[list].current_page).then(res=>{
					this[list] = res.data
				})
			},
			async getMyFriendsList(type) {
				// if()
				this.showLoading();
				const list1 = await this.$api.myGeniusFriendsList()
				if(list1.code == 401){
					this.hideLoading()
					return
				}  	
				this.myGeniusFriendsList = list1.data
				const list2 = await this.$api.careGeniusList()
				this.careGeniusList = list2.data
				this.hideLoading();
				const list3 = await this.$api.GeniusScoreRank()
				this.loading = true
				this.GeniusScoreRank = list3.data
				const list4 = await this.$api.GeniusReputationRank()
				this.GeniusReputationRank = list4.data
				const list5 = await this.$api.GeniusActiveRank()
				this.GeniusActiveRank = list5.data
				const list6 = await this.$api.getGeniusContributeTop()
				this.getGeniusContributeTop = list6.data
				const list7 = await this.$api.myGeniusColleague()
				this.myGeniusColleague = list7.data
				const list8 = await this.$api.myGeniusSchoolmate()
				this.myGeniusSchoolmate = list8.data
				const list9 = await this.$api.recommendGeniusList()
				this.recommendGeniusList = list9.data
			},
			async toCancelFansNperson(item) {
				const fans = await this.$api.cancelGeniusFans({
					user_id: item.id
				})
				if (fans.code == 1) {
					this.$message({
						message: fans.msg,
						type: 'success',
					})
					item.fans_status = 0
				} else {
					this.$message({
						message: fans.msg,
						type: 'warning',
					})
				}

			},
			async toFansNperson(item) {
				const fans = await this.$api.toFansGenius({
					user_id: item.id
				})
				if (fans.code == 1) {
					this.$message({
						message: fans.msg,
						type: 'success',
					})
					item.fans_status = 1
				} else {
					this.$message({
						message: fans.msg,
						type: 'warning',
					})
				}

			},
			isDataString(str) {
				// console.log(str);
				return str.slice(0, 4) === 'data';
			},
			goto(url) {
				this.$router.push(url)
			}
		}
	}
</script>

<style scoped lang="less">
	.main {
		.main-item {
			.bottom-btn {
				display: flex;
				justify-content: flex-end;

				&>div {
					width: 172px;
					height: 47px;
					color: #0052D9;
					line-height: 47px;
					margin-right: 15px;
					text-align: center;
					cursor: pointer;
					border: 1px solid #0052D9;
				}
			}

			.content {
				display: flex;
				// justify-content: space-between;

				.content-item {
					position: relative;
					box-sizing: border-box;
					padding-top: 20px;
					display: flex;
					justify-content: center;
					flex-wrap: wrap;
					background: #F6F6F6;
					margin-left: 20px;
					&:first-child{
						margin-left: 0px;
					}
					.guanzhu {
						width: 48px;
						height: 38px;
						background: #0052D9;
						position: absolute;
						color: white;
						line-height: 38px;
						cursor: pointer;
						text-align: center;
						left: 0;
						top: 0;
					}

					.personPic {
						cursor: pointer;
						width: 122px;
						height: 122px;
						background: #FFFFFF;
						border-radius: 50%;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
						}
					}

					p {
						margin-bottom: 8px;
						width: 100%;
						padding: 0 20px;
						box-sizing: border-box;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					width: 258px;
					height: 260px;
					transition: all 0.5s;
				}

				.content-item:hover {
					transform: scale(1.05);
					box-shadow: 0 3px 6px #7a7a7a;
				}

				padding: 30px 15px;
				box-sizing: border-box;
			}

			.title {
				background: #E5EDFB;

				&>div {
					font-size: 20px;
					color: white;
					line-height: 48px;
					font-weight: bold;
					display: inline-block;
					padding: 0 20px;
					height: 48px;
					background: #0052D9;
					border-radius: 0px 24px 24px 0px;
				}
			}

			padding-bottom: 30px;
			box-sizing: border-box;
			background: white;
		}

		padding: 20px 0;
	}
</style>